'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _colors = require('../utils/colors');

var _colors2 = _interopRequireDefault(_colors);

var _directionalstyles = require('../utils/directionalstyles');

var _directionalstyles2 = _interopRequireDefault(_directionalstyles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (rtl) {
    var fontFamily = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ArialMT, Arial, tahoma, HelveticaNeue';
    var nameMaxWidth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 360;

    var innerHorizontalPadding = 30;
    var innerHorizontalPaddingPx = innerHorizontalPadding + 'px';

    var borderTopRadius = {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px'
    };

    var borderBottomRadius = {
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px'
    };

    var _styles = {
        innerHorizontalPadding: innerHorizontalPadding,

        wrapper: {
            width: '100%',
            fontFamily: fontFamily,
            maxWidth: 600,
            direction: rtl ? 'rtl' : 'ltr',
            borderRadius: 6,
            border: '1px solid #dfe5eb',
            overflow: 'hidden',
            margin: '30px 0',
            background: '#fff'
        },

        table: (0, _extends3.default)({}, borderTopRadius, borderBottomRadius),

        header: (0, _extends3.default)({}, borderTopRadius, {
            padding: '42px ' + innerHorizontalPaddingPx
        }),

        inner: {
            padding: '0 ' + innerHorizontalPaddingPx
        },

        reservationHeader: {
            color: _colors2.default.D40,
            fontSize: 14
        },

        contactDetails: {
            paddingInlineStart: 18,
            fontFamily: fontFamily
        },

        reservationHeaderOrderId: {
            float: rtl ? 'right' : 'left'
        },

        reservationHeaderTime: {
            float: rtl ? 'left' : 'right'
        },

        separator: {
            height: 1,
            backgroundColor: _colors2.default.D60
        },

        contactInfoRow: {
            paddingTop: '36px',
            paddingBottom: '36px'
        },

        contactName: {
            paddingBottom: 12,
            fontSize: 16,
            lineHeight: '24px',
            textOverflow: 'ellipsis',
            maxWidth: nameMaxWidth,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            margin: '0 18px'
        },

        contactMethod: {
            paddingInlineStart: 5,
            paddingInlineEnd: 20,
            fontSize: 14,
            margin: '0 12px'
        },

        contactMethodFirstRow: {
            paddingBottom: 18
        },

        contactMethodIcon: {
            marginInlineEnd: 13,
            width: 18,
            height: 18,
            display: 'inline-block',
            verticalAlign: 'middle'
        },

        contactMethodValue: {
            verticalAlign: 'middle'
        }
    };

    return (0, _directionalstyles2.default)(_styles, rtl);
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wix-restaurants-renderer-js/dist/Reservations/ReservationEmailStyle.style.js
// module id = 407
// module chunks = 0